export const MenuList = [
  {
    title: "Dashboard",
    iconStyle: <i className="flaticon-381-home" />, // better home icon
    to: "dashboard",
  },

  {
    title: "Appointments",
    iconStyle: <i className="flaticon-381-calendar-2" />, // clear calendar icon
    to: "appointments",
  },

  {
    title: "Treatments",
    iconStyle: <i className="flaticon-381-heart-1" />, // medical/health
    to: "treatments",
  },

  {
    title: "Doctors",
    iconStyle: <i className="flaticon-381-user-4" />, // doctor/user
    to: "doctors",
  },

  {
    title: "Events",
    iconStyle: <i className="flaticon-381-calendar" />, // event calendar
    to: "events",
  },

  {
    title: "Executivemembers",
    iconStyle: <i className="flaticon-381-user-7" />, // group/team
    to: "executivemembers",
  },

  {
    title: "TrainingCenter",
    iconStyle: <i className="flaticon-381-book" />, // learning/training
    to: "trainingcenters",
  },

  {
    title: "Fellowship",
    iconStyle: <i className="flaticon-381-star" />, // achievement/fellowship
    to: "fellowship",
  },

  {
    title: "Constitution",
    iconStyle: <i className="flaticon-381-file" />, // document
    to: "constitution",
  },

  {
    title: "Awards",
    iconStyle: <i className="flaticon-381-like" />, // awards
    to: "awards",
  },

  {
    title: "Travel Grant",
    iconStyle: <i className="flaticon-381-map" />, // travel/global
    to: "international-travel-grant",
  },

  {
    title: "Junior Wing",
    iconStyle: <i className="flaticon-381-user-2" />, // young/user
    to: "junior-wing",
  },

  {
    title: "Membership",
    iconStyle: <i className="flaticon-381-id-card" />, // membership card
    to: "membership",
  },
];